import {
    PLACE_ORDER_CHECKOUT,
    PLACE_ORDER_CHECKOUT_SUCCESSFUL,
    PLACE_ORDER_CHECKOUT_FAILED,
} from "./actionTypes";

const initialState = {
    errorMessage: null,
    loading: false,
    success: false,
    error: false,
    orderData: null,
};


const PlaceOrderReducer = (state = initialState, action) => {

    switch (action.type) {
        case PLACE_ORDER_CHECKOUT:
            state = {
                ...state,
                loading: true,
                success: false,
                error: false,
                errorMessage: null,
                orderData: null,
            };
            break;
        case PLACE_ORDER_CHECKOUT_SUCCESSFUL:
            state = {
                ...state,
                loading: false,
                success: true,
                errorMessage: null,
                error: false,
                orderData: action.payload,
            };
            break;
        case PLACE_ORDER_CHECKOUT_FAILED:
            state = {
                ...state,
                loading: false,
                errorMessage: action.payload,
                error: true,
                success: false,
                orderData: null,
            };
            break;
        default:
            state = { ...state };
            break;
    }
    return state;
};

export default PlaceOrderReducer;
